import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth.guard';
import { LoaderProfileComponent } from './core/components/loader-profile/loader-profile.component';
import { GenericErrorComponent } from './error-treatment/components/generic-error/generic-error.component';
import { NotAuthenticatedErrorComponent } from './error-treatment/components/not-authenticated-error/not-authenticated-error.component';
import { NotFoundErrorComponent } from './error-treatment/components/not-found-error/not-found-error.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LoaderProfileComponent
  },
  {
    path: 'callback/ciam',
    redirectTo: 'home'
  },
  {
    path: 'callback/app',
    redirectTo: 'home'
  },
  {
    path: 'callback/isam',
    redirectTo: 'home'
  },
  {
    path: 'home',
    component: LoaderProfileComponent
  },
  {
    path: 'erro',
    component: GenericErrorComponent
  },
  {
    path: 'negado',
    component: NotAuthenticatedErrorComponent
  },
  {
    path: 'login/sts',
    component: LoaderProfileComponent
  },
  {
    path: '**',
    canActivate: [AuthGuard],
    component: NotFoundErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
